// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { operatorId } from './Operator';
import { fermentationScheduledActionId } from './FermentationScheduledAction';
import { invResourceId } from './InvResource';
import { fermentationLineTypeId } from './FermentationLineType';
import { z } from 'zod';
export const fermentationAdditionId = (z.number());
export const fermentationAddition = z.object({
    id: fermentationAdditionId,
    fermentation_id: fermentationId,
    started_at: z.date(),
    ended_at: z.date().nullable(),
    amount_start_mass_g: z.string().nullable(),
    amount_end_mass_g: z.string().nullable(),
    amount_net_added_g: z.string(),
    notes: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    scheduled_action_id: fermentationScheduledActionId.nullable(),
    container_tare_g: z.string().nullable(),
    auto_closed_at_end_of_run: z.boolean(),
    concentration_pct: z.string().nullable(),
    resource_id: invResourceId.nullable(),
    line_type_id: fermentationLineTypeId.nullable(),
});
export const fermentationAdditionInitializer = z.object({
    id: fermentationAdditionId.optional(),
    fermentation_id: fermentationId,
    started_at: z.date(),
    ended_at: z.date().optional().nullable(),
    amount_start_mass_g: z.string().optional().nullable(),
    amount_end_mass_g: z.string().optional().nullable(),
    amount_net_added_g: z.string(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    scheduled_action_id: fermentationScheduledActionId.optional().nullable(),
    container_tare_g: z.string().optional().nullable(),
    auto_closed_at_end_of_run: z.boolean().optional(),
    concentration_pct: z.string().optional().nullable(),
    resource_id: invResourceId.optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
});
export const fermentationAdditionMutator = z.object({
    id: fermentationAdditionId.optional(),
    fermentation_id: fermentationId.optional(),
    started_at: z.date().optional(),
    ended_at: z.date().optional().nullable(),
    amount_start_mass_g: z.string().optional().nullable(),
    amount_end_mass_g: z.string().optional().nullable(),
    amount_net_added_g: z.string().optional(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    scheduled_action_id: fermentationScheduledActionId.optional().nullable(),
    container_tare_g: z.string().optional().nullable(),
    auto_closed_at_end_of_run: z.boolean().optional(),
    concentration_pct: z.string().optional().nullable(),
    resource_id: invResourceId.optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
});
//# sourceMappingURL=FermentationAddition.js.map